import React from 'react';
import Sidenavigation from '../../Manager/Layouts/Sidenavigation';
import Topnavigation from '../../Manager/Layouts/Topnavigation';
import Content from '../sections/CustomerRatings/Content';
import { Helmet } from "react-helmet";

export default function CustomerRatings() {

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ">
            {/* title */}
            <Helmet>
                <title>Customer Ratings</title>
            </Helmet>

            {/* sidebar start  */}
            <Sidenavigation />
            {/* sidebar end */}

            <main className="body-content">

                {/* Topnavigation start */}
                <Topnavigation />
                {/* Topnavigation end  */}

                {/* page content start  */}
                <Content Page='Manager' />
                {/* page content end  */}

            </main>

        </div>
    );
};